<template>
  <div id="app_content" class="reserved">
    <div
        v-if="background && isMounted && cod_family"
        class="section-top d-flex"
        :class="cod_family === 'CIN' || cod_family === '4CLEAN' ? cod_family.replace('4', '') : ''"
        :style="{ backgroundImage: 'url(' + background + ')' }">
    </div>
    <!-- <div class="section-flex" >
      <div class="w-image">
        <img :src="url('/media/image-page/macrofamily-CIN_old.png')" alt="Immagine Macrofamiglia">
      </div>
      <div class="w-text">
        <h1 class="mt-0 ttl">{{macrofamily.descrizione}}</h1>
        <a class="link-ret purple" :href="url('/b2b/macrofamily-article/'+macrofamily.codice)">Scopri</a>
      </div>
    </div> -->

    <div class="section-flex-collection" v-if="families && isMounted">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 scopri-anche">
            <a  v-if="cod_family === 'CIN'" :href="url('/b2b/macrofamily-article/NAS')">
              {{ trans.get('b2b.macrofamily.explore-nas')}}
              <svg xmlns="http://www.w3.org/2000/svg" width="25.45" height="11.322" viewBox="0 0 25.45 11.322">
                <g id="Raggruppa_269" data-name="Raggruppa 269" transform="translate(-626.257 -107.125)">
                  <path id="Tracciato_94" data-name="Tracciato 94" d="M-293.192,276.7l4.346-3.022a2.682,2.682,0,0,0-.014-4.5l-4.331-2.975" transform="translate(938.836 -158.66)" fill="none" stroke="#0091ff" stroke-miterlimit="10" stroke-width="1"></path>
                  <line id="Linea_13" data-name="Linea 13" x1="24.858" transform="translate(626.257 112.81)" fill="none" stroke="#0091ff" stroke-miterlimit="10" stroke-width="1"></line>
                </g>
              </svg>
            </a>
            <a  v-if="cod_family === 'NAS'" :href="url('/b2b/macrofamily-article/CIN')">
              {{ trans.get('b2b.macrofamily.explore-cin')}}
              <svg xmlns="http://www.w3.org/2000/svg" width="25.45" height="11.322" viewBox="0 0 25.45 11.322">
                <g id="Raggruppa_269" data-name="Raggruppa 269" transform="translate(-626.257 -107.125)">
                  <path id="Tracciato_94" data-name="Tracciato 94" d="M-293.192,276.7l4.346-3.022a2.682,2.682,0,0,0-.014-4.5l-4.331-2.975" transform="translate(938.836 -158.66)" fill="none" stroke="#0091ff" stroke-miterlimit="10" stroke-width="1"></path>
                  <line id="Linea_13" data-name="Linea 13" x1="24.858" transform="translate(626.257 112.81)" fill="none" stroke="#0091ff" stroke-miterlimit="10" stroke-width="1"></line>
                </g>
              </svg>
            </a>

          </div>
          <div class="col-md-12">
            <h1 v-if="families[0].macrofamily.descrizione.match(/^\d/)">
              {{ families[0].macrofamily.descrizione.slice(0, 1) + '-' + families[0].macrofamily.descrizione.slice(1).charAt(0) }}{{
                families[0].macrofamily.descrizione.slice(2).toLowerCase()
              }}

            </h1>
            <h1 v-else-if="families[0].macrofamily.descrizione ==='' && families[0].macrofamily.codice.match(/^\d/) " class="my-h1">
              {{ families[0].macrofamily.codice.slice(0, 1) + '-' + families[0].macrofamily.codice.slice(1).charAt(0)}}{{
                families[0].macrofamily.codice.slice(2).toLowerCase()
              }}
            </h1>
            <h1 v-else class="my-h1">
              {{ families[0].macrofamily.descrizione }}
            </h1>
          </div>
          <div
              class="element col-md-6"
              v-for="(f, i) in families"
              v-if="f.articles.length > 0"
          >
            <div class="texture">
              <div class="w-content">
                <div class="w-image">
                  <!-- todo  cambiare icona CUS-->
                  <img
                      v-if="f.codice === 'CUS'"
                      :src="url('/storage/media/icons/svg/family/black/e.svg')"
                      alt="icon"
                  />
                  <img
                      v-else-if="f.codice === 'V+'"
                      :src="url('/storage/media/icons/svg/family/black/vplus.svg')"
                      alt="icon"
                  />
                  <img
                      v-else
                      :src="
                      url(
                        '/storage/media/icons/svg/family/black/' +
                          f.codice.toLowerCase() +
                          '.svg'
                      )
                    "
                      alt="icon"
                  />
                </div>
                <div class="w-text">
                  <h3 class="ttl special">
                    {{ f.descrizione }}
                  </h3>

                  <small v-if="f.descrizione ===''">{{ f.des_estesa }}</small>
                  <a
                      class="link-ret green"
                      :href="url('/b2b/family/' + f.codice)"
                  >{{ trans.get("b2b.explore") }}</a>
                  <!--                  <a v-else-->
                  <!--                     class="link-ret green"-->
                  <!--                     :href="url('/b2b/family/' + f.codice)"-->
                  <!--                  >{{ trans.get("b2b.explore") }}</a-->
                  <!--                  >-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-flex-collection" v-if="!families">
      <div class="container-fluid">
        <div class="row">
          <div class="element col-md-12">
            <p class="mx-6 my-6">Nessuna famiglia trovata per {{ cod_family }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data: function () {
    return {
      background: "",
      cod_family: "",

      loading: false,
      isMounted: false,
      families: null,
      currentBreadcrumb: [],

      category_1: [
        this.url("/media/icons/svg/cat-1/01-round-belt-black.svg"),
        this.url("/media/icons/svg/cat-1/02-tubular-belt.svg"),
        this.url("/media/icons/svg/cat-1/03-v-belt.svg"),
        this.url("/media/icons/svg/cat-1/04-v-belt-+.svg"),
        this.url("/media/icons/svg/cat-1/05-twin-belt.svg"),
        this.url("/media/icons/svg/cat-1/06-crest-belt.svg"),
      ],
    };
  },

  mounted() {
    this.loadMacrofamily();
  },

  methods: {
    loadMacrofamily: function () {
      var vue = this;
      vue.loading = true;
      let pathname = window.location.pathname.split("/");
      let cod_family = pathname[pathname.length - 1];
      this.cod_family = cod_family;
      this.background = "/storage/media/vetrina/bg/" + cod_family + ".jpg";
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: cod_family,
          type: "macro",
          public: false
        },
      })
          .then((res) => {
            //console.log(res.data.family)
            if (res.data.family) this.families = res.data.family;
            // this.currentBreadcrumb.push(this.macrofamily.descrizione)
            vue.isMounted = true;
            //console.log(this.families);
          })
          .catch((err) => {
            vue.loading = false;

            vue.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.djcaid-fccc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.my-h1 {
  text-transform: lowercase;
  margin: 30px 0;

  &:first-letter {
    text-transform: uppercase;
  }
}
.scopri-anche {
  color: #0091FF;
  margin-top: 20px;
 a {
   display: flex;
   align-items: baseline;
 }
  a:hover {
    color: #0091FF;
  }
  a svg {
    margin-left: 8px;
    transform: scale(1.2);
  }
}
.section-top {
  height: 12vh;

  background-color: #fff;
  color: white;
  background-size: 100%;
  background-repeat: no-repeat;


  .row {
    height: 100%;

    h1 {
      color: var(--dark-gray);
      margin: 30px;
    }
  }

  &.CIN {
    background-repeat: no-repeat;
    background-color: #000;
    background-size: cover;
    background-position: 80% 0;

    .row {
      justify-content: flex-end;
    }

    h1 {
      color: #fff;
      transform: rotateY(180deg);
      text-shadow: none;
    }
  }
  &.CLEAN {
    background-position: 0 50%;
  }

  h1 {
    //text-transform: lowercase;
    font-size: 30px;
    font-weight: normal;

    &:first-letter {
      text-transform: capitalize;
    }
  }
}

.section-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--background-gray-2);
  margin: 1em 0;
}

.section-flex-collection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0.5em 0 10px;

  .element {
    width: 100%;

    .texture {
      padding: 8em 0;
      width: 100%;
      height: 430px;
      background-color: var(--background-gray-2);
      display: flex;
      align-items: center;
      justify-content: center;

      .w-content {
        width: 50%;

        .w-image {
          width: 49px;
          margin: 20px 0;

          img {
            width: 100%;
            display: block;
          }
        }

        .w-text {
          .ttl {
            text-transform: unset;
            font-weight: 400;

            &.special {
              text-transform: lowercase;

              &:first-letter {
                text-transform: uppercase;
              }

            }
          }

          h3 {
            margin: 15px 0;
            font-weight: bold;
          }

          small {
            font-size: 0.8rem;
            margin: 10px 0;
          }

          a.link-ret.green {
            margin-top: 20px;
            &:hover {
              border-color: transparent;
            }
          }
        }
      }
    }
  }
}

/* Pari */
.section-flex-collection .element:nth-child(2n) {
  padding: 5px 0;
}

/* Dispari */
.section-flex-collection .element:nth-child(2n + 1) {
  padding: 5px 0;
}

.section-flex-collection .element:nth-child(2n) .texture {
  /* justify-content: flex-start; */
}

.section-flex-collection .element:nth-child(2n) .texture .w-content {
  /* margin-left: 20%; */
}

.section-flex-collection .element:nth-child(2n + 1) .texture {
  /* justify-content: flex-end; */
}

.section-flex-collection .element:nth-child(2n + 1) .texture .w-content {
  /* margin-right: 20%; */
}

@media (min-width: 768px) {
  .section-top {
    height: 20vh;
  }

  .section-flex-collection {
    .element {
      width: 50%;

      &:nth-child(2n) {
        padding: 5px 0px 5px 5px;
      }

      :nth-child(2n + 1) {
        //padding: 5px 5px 5px 0px;
      }
    }
  }
}

@media (min-width: 1200px) {
  .section-top {
    height: 50vh;
  }
}
@media (min-width: 1600px) {
  .row {
    max-width: calc(100% - 100px);
  }
}
</style>
